import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import cuid from 'cuid';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TitleConfig, TypographyConfig } from '@vds-core/typography';
import { colors } from '@vds-core/theme';
/*
fontWeightBold represents the font weight found in 
typography used when the component is bolded. Font weight is
not exported by typography configs due to the fact that 
typography components may have multiple font weight options
*/

var fontWeightBold = 'bold';
var propTypes = {
  /**
   * @ignore
   * ref for component
   */
  setTriggerRef: PropTypes.func,

  /**
   * @ignore
   * config for colors
   */
  color: PropTypes.object,

  /**
   * @ignore
   * boolean that, if true, changes the hover states
   */
  size: PropTypes.oneOf(['large', 'normal', 'medium', 'small']),

  /**
   * @ignore
   * boolean that, if true, changes the hover states
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * @ignore
   * prop that changes the padding between the text and the bottom line
   */
  triggerPaddingBottom: PropTypes.string,

  /**
   * @ignore
   * string that changes which typescale to use for typography
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * config for body typography
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * config for title typography
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   * boolean that, if true, adds an additional hit area
   */
  hitArea: PropTypes.bool,

  /**
   * @ignore
   * boolean that, if true, changes the focus states
   */
  focusState: PropTypes.bool
};
var defaultProps = {
  size: 'large',
  viewport: 'desktop',
  color: colors,
  hitArea: false,
  focusState: false,
  triggerPaddingBottom: calculateRem(2),
  typescale: TypographyConfig.getTypescale(),
  bodyConfig: BodyConfig,
  titleConfig: TitleConfig
};

var _getBorderColor = function _getBorderColor(error, disabled, inverted, color) {
  if (error) {
    return color.orange;
  } else if (!disabled && !inverted) {
    return color.black;
  } else if (inverted) {
    return disabled ? color.coolGray10 : color.white;
  } else {
    return color.coolGray3;
  }
};

var _getTextColor = function _getTextColor(disabled, inverted, selected, color) {
  if (!disabled && !selected) {
    return color.coolGray6;
  } else if (!disabled && selected) {
    return inverted ? color.white : color.black;
  } else if (disabled) {
    return inverted ? color.coolGray10 : color.coolGray3;
  }
};

var Trigger = /*#__PURE__*/styled.button.withConfig({
  displayName: "Trigger",
  componentId: "sc-3o9m2k-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background: ", ";\n  border-bottom: ", ";\n  border-top: 0;\n  border-right: 0;\n  border-left: 0;\n  padding: 0;\n  margin: 0;\n  padding-bottom: ", ";\n  color: ", ";\n  cursor: ", ";\n  position: relative;\n  transition: border 300ms;\n  transition: color 300ms;\n  overflow: ", ";\n  text-overflow: ellipsis;\n  z-index: 1;\n  white-space: nowrap;\n  &.focus-visible {\n    background: ", ";\n    color: ", ";\n    transition: color 300ms;\n  }\n\n  ", "\n\n  &:hover,\n  &:active {\n    outline: none;\n    outline-offset: 0;\n  }\n\n  font-weight: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  ", "\n\n  * {\n    outline: none;\n    outline-offset: 0;\n  }\n"])), function (_ref) {
  var color = _ref.color,
      inverted = _ref.inverted;
  return inverted ? color.black : 'transparent';
}, function (_ref2) {
  var error = _ref2.error,
      borderColor = _ref2.borderColor;
  var borderHeight = calculateRem(error ? 4 : 1);
  return "".concat(borderHeight, " solid ").concat(borderColor);
}, function (_ref3) {
  var triggerPaddingBottom = _ref3.triggerPaddingBottom;
  return triggerPaddingBottom;
}, function (_ref4) {
  var fontColor = _ref4.fontColor;
  return fontColor;
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref6) {
  var hitArea = _ref6.hitArea;
  return hitArea ? 'visible' : 'hidden';
}, function (_ref7) {
  var color = _ref7.color,
      inverted = _ref7.inverted;
  return inverted ? color.black : color.white;
}, function (_ref8) {
  var color = _ref8.color,
      inverted = _ref8.inverted;
  return inverted ? color.white : color.black;
}, function (_ref9) {
  var focusState = _ref9.focusState,
      color = _ref9.color,
      inverted = _ref9.inverted;
  return focusState && "\n    &:focus:not(:hover) {\n      outline: none;\n      color: ".concat(inverted ? color.white : color.black, ";\n      &::before {\n        content: '';\n        border: ").concat(calculateRem(1), " dashed ").concat(inverted ? color.white : color.black, ";\n        box-sizing: border-box;\n        left: 50%;\n        position: absolute;\n        top: calc(50% + 1px); // 1px to account for bottom border of each list item\n        transform: translate(-50%, -50%);\n        width: calc(100% + 6px);\n        height: calc(100% + 7px);\n      }\n    }\n\n    :-moz-focusring {\n      color: transparent;\n      text-shadow: 0 0 0 #000;\n    }\n\n");
}, fontWeightBold, function (_ref10) {
  var body = _ref10.body;
  return body.fontFamily;
}, function (_ref11) {
  var body = _ref11.body;
  return calculateRem(body.fontSize);
}, function (_ref12) {
  var body = _ref12.body;
  return calculateRem(body.lineHeight);
}, function (_ref13) {
  var disabled = _ref13.disabled,
      color = _ref13.color,
      inverted = _ref13.inverted;
  return !disabled && "\n      &:hover {\n        transition: color 300ms;\n        color: ".concat(inverted ? color.white : color.black, ";\n      }\n  ");
});
var TriggerWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TriggerWrapper",
  componentId: "sc-3o9m2k-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"])));
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "sc-3o9m2k-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: ", ";\n  display: inline-block;\n  height: ", ";\n  width: 100%;\n  z-index: 1;\n"])), function (_ref14) {
  var disabled = _ref14.disabled;
  return disabled ? 'default' : 'pointer';
}, calculateRem(44));
/**
 * @ignore
 */

var DropdownTrigger = /*#__PURE__*/function (_Component) {
  _inherits(DropdownTrigger, _Component);

  var _super = _createSuper(DropdownTrigger);

  function DropdownTrigger() {
    var _this;

    _classCallCheck(this, DropdownTrigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.setTriggerRef(_this.triggerElem);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerId", cuid());

    _defineProperty(_assertThisInitialized(_this), "refKey", UNSAFE_SetEnvRef());

    return _this;
  }

  _createClass(DropdownTrigger, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _extends2;

      var _this$props = this.props,
          hitArea = _this$props.hitArea,
          color = _this$props.color,
          inverted = _this$props.inverted,
          focusState = _this$props.focusState,
          size = _this$props.size,
          typescale = _this$props.typescale,
          disabled = _this$props.disabled,
          viewport = _this$props.viewport,
          titleConfig = _this$props.titleConfig,
          bodyConfig = _this$props.bodyConfig,
          error = _this$props.error,
          selected = _this$props.selected;
      var fontScale;

      if (size === 'small' && typescale !== 'VDS') {
        fontScale = 'desktop';
      } else {
        fontScale = viewport === 'mobile' ? 'mobile' : 'desktop';
      }

      var fontSize;

      if (typescale === 'VDS') {
        fontSize = size === 'small' ? 'small' : 'large';
      } else {
        if (size === 'small') {
          fontSize = viewport === 'mobile' ? 'small' : 'medium';
        } else {
          fontSize = 'large';
        }
      }

      var typeConfig;

      if (size !== 'small' || typescale === 'VDS') {
        typeConfig = titleConfig;
      } else {
        typeConfig = bodyConfig;
      }

      var body = typeConfig.getStyles(typescale, fontScale, fontSize);
      return /*#__PURE__*/React.createElement(Trigger, _extends((_extends2 = {
        body: body,
        bodyConfig: bodyConfig,
        titleConfig: titleConfig,
        typescale: typescale,
        viewport: viewport
      }, _defineProperty(_extends2, "body", body), _defineProperty(_extends2, "size", size), _defineProperty(_extends2, "focusState", focusState), _defineProperty(_extends2, "hitArea", hitArea), _defineProperty(_extends2, "inverted", inverted), _defineProperty(_extends2, "color", color), _defineProperty(_extends2, "borderColor", _getBorderColor(error, disabled, inverted, color)), _defineProperty(_extends2, "fontColor", _getTextColor(disabled, inverted, selected, color)), _defineProperty(_extends2, "role", "listbox"), _defineProperty(_extends2, "aria-owns", "dropdown-list"), _defineProperty(_extends2, "aria-haspopup", "listbox"), _defineProperty(_extends2, "aria-labelledby", "".concat(this.props.listId, " ").concat(this.triggerId)), _extends2), this.props, _defineProperty({}, this.refKey, function (elem) {
        return _this2.triggerElem = elem;
      })), hitArea && /*#__PURE__*/React.createElement(HitArea, {
        disabled: disabled,
        size: size,
        viewport: viewport,
        tabIndex: -1
      }), /*#__PURE__*/React.createElement(TriggerWrapper, {
        tabIndex: -1
      }, this.props.children));
    }
  }]);

  return DropdownTrigger;
}(Component);

DropdownTrigger.defaultProps = defaultProps;
DropdownTrigger.propTypes = propTypes;
export default DropdownTrigger;